document.addEventListener("DOMContentLoaded", function() {
  const variantPicker = document.querySelector('[name="id"]');
  if (variantPicker) {
    variantPicker.addEventListener('change', function(event) {
      updateVariantMetafield();
    });
  }

  // 初回ロード時に正しいメタフィールドとボタンを表示
  updateVariantMetafield();
});

function updateVariantMetafield() {
  const selectedVariantId = document.querySelector('[name="id"]').value;
  const allVariantMetafields = document.querySelectorAll('.variant-metafields-data');

  // 全てのメタフィールドを非表示にする
  allVariantMetafields.forEach(metafield => {
    metafield.style.display = 'none';
  });

  // 選択されたバリアントに関連するメタフィールドを表示する
  const relatedMetafields = document.querySelectorAll(`.variant-metafields-data[data-variantid="${selectedVariantId}"]`);
  relatedMetafields.forEach(metafield => {
    metafield.style.display = 'block';
  });
}

